module.exports = __webpack_public_path__ + "static/img/login_bg.4668124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/login_bg.png
// module id = CqSw
// module chunks = 2